import React from 'react'
import { useTranslation } from 'react-i18next'

import { User } from '../../../common/validations'
import {
  InvoiceAddress,
  InvoiceAddressType,
} from '../../../common/validations/invoiceAddress'
import { useModuleConfig } from '../../hooks/useModuleConfig/useModuleConfig'

import { TextTable } from 'components'

export const UserInfoView = ({
  user,
  invoiceAddress,
}: {
  user: User
  invoiceAddress?: InvoiceAddress | null
}) => {
  const { t } = useTranslation(['common'])
  const {
    userInfo: { showCommunicationPreferences },
  } = useModuleConfig()

  const getCommunicationWays = () => {
    const communications = []
    if (user.communicationByEmail) {
      communications.push(t('common:communicationByEmail'))
    }
    if (user.communicationBySms) {
      communications.push(t('common:communicationBySms'))
    }
    return communications
  }

  return (
    <TextTable className="flex flex-col space-y-2 text-sm">
      <TextTable.Row>
        <TextTable.Cell>{t('common:residentId')}</TextTable.Cell>
        <TextTable.Cell className="[word-break:break-word]">
          {user.cognitoId ?? ''}
        </TextTable.Cell>
      </TextTable.Row>
      <TextTable.Row>
        <TextTable.Cell>{t('common:emailForContact')}</TextTable.Cell>
        <TextTable.Cell className="[word-break:break-word]">
          {user.email ?? ''}
        </TextTable.Cell>
      </TextTable.Row>
      <TextTable.Row>
        <TextTable.Cell>{t('common:phone')}</TextTable.Cell>
        <TextTable.Cell>{user.phoneNumber ?? ''}</TextTable.Cell>
      </TextTable.Row>
      {showCommunicationPreferences && (
        <TextTable.Row>
          <TextTable.Cell>{t('common:waysToCommunicate')}</TextTable.Cell>
          <TextTable.Cell>
            {getCommunicationWays().map((communication) => (
              <TextTable.Row key={communication}>{communication}</TextTable.Row>
            ))}
          </TextTable.Cell>
        </TextTable.Row>
      )}
      <TextTable.Row>
        <TextTable.Cell>
          {t('common:userInfo.permissionsHeader')}
        </TextTable.Cell>
        <TextTable.Cell>
          {user.marketingAllowed && t('common:marketingAllowed')}
        </TextTable.Cell>
      </TextTable.Row>
      {invoiceAddress?.postalInvoiceAddress && (
        <TextTable.Row>
          <TextTable.Cell>{t('common:paperInvoice')}</TextTable.Cell>
          <TextTable.Cell>
            {invoiceAddress.postalInvoiceAddress.invoiceRecipientName && (
              <TextTable.Row>
                {invoiceAddress.postalInvoiceAddress.invoiceRecipientName}
              </TextTable.Row>
            )}
            <TextTable.Row>
              {invoiceAddress.postalInvoiceAddress.streetAddressLine1}
            </TextTable.Row>
            {invoiceAddress.postalInvoiceAddress.streetAddressLine2 && (
              <TextTable.Row>
                {invoiceAddress.postalInvoiceAddress.streetAddressLine2}
              </TextTable.Row>
            )}
            <TextTable.Row>
              {invoiceAddress.postalInvoiceAddress.postalCode}{' '}
              {invoiceAddress.postalInvoiceAddress.city}
            </TextTable.Row>
          </TextTable.Cell>
        </TextTable.Row>
      )}
      {invoiceAddress?.selectedInvoiceType ===
        InvoiceAddressType.CORPORATE_ELECTRONIC && (
        <TextTable.Row>
          <TextTable.Cell>{t('common:eInvoice')}</TextTable.Cell>
          <TextTable.Cell>{t('common:inUse')}</TextTable.Cell>
        </TextTable.Row>
      )}
    </TextTable>
  )
}
